import { render, staticRenderFns } from "./DashboardCards.vue?vue&type=template&id=a023f176"
import script from "./DashboardCards.vue?vue&type=script&lang=js"
export * from "./DashboardCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports